import { render, staticRenderFns } from "./GiftTile.vue?vue&type=template&id=edb7e8a0&"
import script from "./GiftTile.vue?vue&type=script&lang=js&"
export * from "./GiftTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports